<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div [class.slds-has-error]="!valid" class="slds-form-element">
  <label *ngIf="ff"
         [for]="theId"
         class="slds-form-element__label">
    <abbr *ngIf="isUiRequired" class="slds-required" title="required">* </abbr>
    {{ label }}
    <small>{{ ff.description }}</small>
  </label>
  <div class="slds-form-element__control" style="min-width: 9em">
    <input #inp
           (blur)="onBlur($event)"
           (focus)="onFocus()"
           (keyup)="onKeyUp($event)"
           [class.ng-dirty]="control?.dirty"
           [id]="theId"
           [name]="propertyName"
           [title]="label"
           [required]="isUiRequired"
           [readOnly]="isReadOnly"
           autocomplete="off"
           class="slds-input"
           inputmode="decimal"
           style="text-align: right"
           type="text">
    <div class="slds-form-element__help">{{ errorMessage }}</div>
  </div>
</div>
